// app/(dashboard)/client-layout.tsx
'use client';

import DefaultLayout from '@/components/layouts/DefaultLayout';
export default function DashboardClientLayout({
  children
}: Readonly<{
  children: React.ReactNode;
}>) {
  return <DefaultLayout data-sentry-element="DefaultLayout" data-sentry-component="DashboardClientLayout" data-sentry-source-file="ClientLayout.tsx">{children}</DefaultLayout>;
}